import React from 'react';

// Translations
import messages from './messages';
import { useIntl } from 'react-intl';

// Model
import { PlaceOfJurisdictionModel } from '../../models/PlaceOfJurisdictionModel';

// Resources
import { useDownloadPoaOrPPoa } from '../../services/resources/poaAndPpoa';
import { useCoBrandingParams } from '../../hooks/useCobrandingParams';

interface PermissionDescriptionProps {
  placeOfJurisdiction: PlaceOfJurisdictionModel | undefined;
  passengerId?: string;
  lettersToSign: LetterTypes[];
  productType?: string;
}

export type LetterTypes =
  | 'power-of-attorney'
  | 'partner-power-of-attorney'
  | 'court-power-of-attorney';

const typeToTranslationMap = {
  'power-of-attorney': 'poa',
  'partner-power-of-attorney': 'ppoa',
  'court-power-of-attorney': 'cpoa',
};

const PermissionDescription = ({
  placeOfJurisdiction,
  passengerId,
  lettersToSign,
  productType,
}: PermissionDescriptionProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const { dynamicConfig } = useCoBrandingParams();
  const lawyerId = localStorage.getItem('yo:lawyerId');

  const linkProps = {
    className: 'link',
    target: '_blank',
    rel: 'noreferrer',
  };

  const handleClick = useDownloadPoaOrPPoa({
    passengerId,
    placeOfJurisdictionId: placeOfJurisdiction?.id,
  });

  const translations: any = {};

  lettersToSign?.forEach(value => {
    // eslint-disable-next-line react/no-multi-comp
    translations[typeToTranslationMap[value]] = (...chunks: string[]) => {
      return (
        // eslint-disable-next-line
        <a {...linkProps} onClick={() => handleClick(value)}>
          {chunks}
        </a>
      );
    };
  });

  const tacAndPoa =
    productType === 'french_court_delays'
      ? {
          // eslint-disable-next-line react/no-multi-comp
          tac: (...chunks: string[]) => (
            <a
              {...linkProps}
              href={`https://${dynamicConfig.portalUrl}/termsOfServices/download?filter[product_type]=${productType}`}
            >
              {chunks}
            </a>
          ),
          ...translations,
        }
      : lawyerId === '32'
      ? {
          // eslint-disable-next-line react/no-multi-comp
          tac: (...chunks: string[]) => (
            <a {...linkProps} href={dynamicConfig?.termsOfServiceUrl}>
              {chunks}
            </a>
          ),
          // eslint-disable-next-line react/no-multi-comp
          prices: (...chunks: string[]) => (
            <a {...linkProps} href={dynamicConfig?.pricingListUrl}>
              {chunks}
            </a>
          ),
          ...translations,
        }
      : {
          // eslint-disable-next-line react/no-multi-comp
          tac: (...chunks: string[]) => (
            <a {...linkProps} href={dynamicConfig?.termsOfServiceUrl}>
              {chunks}
            </a>
          ),
          // eslint-disable-next-line react/no-multi-comp
          prices: (...chunks: string[]) => (
            <a {...linkProps} href={dynamicConfig?.pricingListUrl}>
              {chunks}
            </a>
          ),
          ...translations,
        };

  const message =
    productType === 'french_court_delays'
      ? messages.permissionDescriptionFrenchCourt
      : lawyerId === '32'
      ? messages.permissionDescriptionJarolim
      : messages.permissionDescription;

  return (
    <div className="mt-10 text-sm sm:text-base text-center md:text-left">
      {formatMessage(message, {
        poa: null,
        ppoa: null,
        cpoa: null,
        ...tacAndPoa,
      })}
    </div>
  );
};

export default PermissionDescription;
